import GBreadcrumbs from './GBreadcrumbs.vue';

export default GBreadcrumbs;

export { GBreadcrumbs };
